import React, { useState } from 'react';
import '../App.css'; // Import the common CSS file
import { useFileContext } from '../context/FileContext';


const Step2 = ({ onPrev, onNext, data }) => {
  const [computerLiteracy, setComputerLiteracy] = useState({
    internetAccess: false,
    gmailAccount: false,
    wordProcessing: false,
    accessToComputer: false,
  });

  const { fileData, setFile } = useFileContext();
  const handlePrev = () => {
    onPrev();
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setComputerLiteracy((prevData) => ({ ...prevData, [name]: checked }));
  };

  const handleFileUpload = (e, fileType) => {
    const file = e.target.files[0];
    setFile(fileType, file);
  };

  const handleNext = () => {

    onNext({ ...data, computerLiteracy, fileUploads: fileData });
  };

  return (
    <div className="container">
      <div className="form-container">
        <h2>Step 2 of 3:</h2>


        <h2>Computer Literacy</h2>
        <div className="checkbox-container">

          <div className="checkbox-label">
            <input
              type="checkbox"
              name="internetAccess"
              checked={computerLiteracy.internetAccess}
              onChange={handleCheckboxChange}
            />
            <label>I have consistent Internet access</label>
          </div>

          <div className="checkbox-label">
            <input
              type="checkbox"
              name="gmailAccount"
              checked={computerLiteracy.gmailAccount}
              onChange={handleCheckboxChange}
            />
            <label>I have an active email account</label>
          </div>


          <div className="checkbox-label">
            <input
              type="checkbox"
              name="wordProcessing"
              checked={computerLiteracy.wordProcessing}
              onChange={handleCheckboxChange}
            />
            <label>I have knowledge and access to Word Processing Programmes</label>
          </div>

          <div className="checkbox-label">
            <input
              type="checkbox"
              name="accessToComputer"
              checked={computerLiteracy.accessToComputer}
              onChange={handleCheckboxChange}
            />
            <label>I have regular access to a laptop or desktop to complete my studies</label>
          </div>
        </div>

        {/* //============================== */}

        <h2>File Uploads</h2>
        <p className="bold-text" >Please note we need the following documents to consider your application</p>


        <label>
          A certified copy of your ID document or Passport:
          <input
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            onChange={(e) => handleFileUpload(e, 'idCopy')}
          />
        </label>

        <label>
          A certified copy of your Matriculation Certificate / School Leaver Certificate:
          <input
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            onChange={(e) => handleFileUpload(e, 'matricCertificate')}
          />
        </label>

        <label>
          If Recognition of Prior Learning (RPL) or Credit Accreditation and Transfer (CAT) credit is required,
          please supply transcripts and other documents to support your application:
          <span style={{ color: 'red' }}> If there are more than one document, please combine them and then upload. </span>
          <input
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            onChange={(e) => handleFileUpload(e, 'transcripts')}
          />
        </label>

        <label>
          Proof of payment of the non-refundable Application Fee:
          <input
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            onChange={(e) => handleFileUpload(e, 'proofOfPayment')}
          />
        </label>

        <label>
          A pastoral reference letter from the pastor of the church that you are a member of:
          <input
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            onChange={(e) => handleFileUpload(e, 'pastoralReference')}
          />
        </label>

        <div className="buttons">
          <button onClick={handlePrev}>Back</button>
          <button onClick={handleNext}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default Step2;
